import type { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useAccordionOrganizationMenuStyles = makeStyles((theme: Theme) => ({
    accordion: {
        minHeight: 50,
        maxHeight: 50,
        "&.Mui-expanded": {
            minHeight: 50,
            maxHeight: 50,
        },
    },
    verticalMargin: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    accordionContent: {
        maxHeight: "40vh",
        overflowY: "auto",
    },
}));
